import React, { Fragment } from 'react';
import { IonFab, IonFabButton, IonIcon } from '@ionic/react';
import { add, pencilOutline } from 'ionicons/icons';

const FloatingActionButton: React.FC = (props: any) => {
  const icon = props.children.includes('edit') ? pencilOutline : add;

  return (
    <Fragment>
      {/*-- fab placed to the top end --*/}
      <IonFab vertical="top" horizontal="end" slot="fixed">
        <IonFabButton color="light" routerLink={props.children}>
          <IonIcon icon={icon} />
        </IonFabButton>
      </IonFab>
    </Fragment>
  );
};

export default FloatingActionButton;
